import { render } from "./ReviewRequest.vue?vue&type=template&id=d25484d4&ts=true"
import script from "./ReviewRequest.vue?vue&type=script&lang=ts"
export * from "./ReviewRequest.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\src\\ApplicantPortal.Web\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__